import React from "react";
import Line from "./line";

const Pager = ({
	first,
	last,
	navigate,
	page,
	pageCount,
}) =>
	<ul className="pager">
		<li className={["back",    (page === 0 ? "disabled" : "")].join(" ")}><button onClick={() => first()}>« First</button></li>
		<li className={["back",    (page === 0 ? "disabled" : "")].join(" ")}><button onClick={() => navigate(-1)}>‹ Previous</button></li>
		<li className={["forward", (page === pageCount-1 ? "disabled" : "")].join(" ")}><button onClick={() => navigate( 1)}>Next ›</button></li>
		<li className={["forward", (page === pageCount-1 ? "disabled" : "")].join(" ")}><button onClick={() => last()}>Last »</button></li>
	</ul>

const View = ({
	commit,
	end,
	opened,
	page,
	pages,
	results,
	resultsPage,
	start,

	handleOpen,
	first,
	last,
	navigate,
}) =>
			<div>
				<p>
					<em>
						Showing results{" "}
						{start}-{end}{" "}
						of{" "}
						{results.length}
					</em>
				</p>
				<Pager {...{first, last, navigate, page, pageCount: pages.length}} />
				<table className="table table-hover" id="search-results">
					<thead>
						<tr>
							<th>Package name</th>
							<th>Attribute name</th>
							<th>Description</th>
						</tr>
						<tr>
						</tr>
					</thead>
					<tbody>
						{
							resultsPage.map((r, key) =>
								<Line
									{...r}
									key={key}
									handleOpen={handleOpen}
									opened={r["attribute"] === opened}
									commit={commit}
									className={(key+1) % 2 ? "odd" : "even"}
								/>
						)}
					</tbody>
				</table>
				<Pager {...{first, last, navigate, page, pageCount: pages.length}} />
				<div>
					Page {page + 1}/{pages.length}
				</div>
			</div>


export default View;



// WEBPACK FOOTER //
// ./src/view.js